import { Login } from "models/Resources/Login";
import { LoginResponse } from "models/Responses/LoginResponse";

export function loginResponseToLoginResource(
  loginResponse: LoginResponse
): Login {
  const loginResource: Login = {
    success: false,
    token: "",
    user: "",
    name: "",
    storeNumber: "",
    message: "",
    authorizations: [],
  };
  loginResource.success = loginResponse.succes;
  loginResource.token = loginResponse.jwttoken;
  loginResource.user = loginResponse.usager;
  loginResource.name = loginResponse.nom;
  loginResource.storeNumber = loginResponse.magasin;
  loginResource.message = loginResponse.message;
  loginResource.authorizations = loginResponse.authorization;
  return loginResource;
}
